// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__gilroyRegular_e7b5b6', '__gilroyRegular_Fallback_e7b5b6'","fontWeight":400},"className":"__className_e7b5b6","variable":"__variable_e7b5b6"};